import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { OptInModalDisclosureComponent } from './opt-in-modal-disclosure.component';

@Component({
  selector: 'app-opt-in-modal',
  templateUrl: './opt-in-modal.component.html',
  styleUrls: ['./opt-in-modal.component.scss', './styles.scss'],
  standalone: false,
})
export class OptInModalComponent implements OnInit {
  customerPortalDisclosureText = `Exciting news! You can now receive offers that are personalized to you.
  Opt in today.`;
  constructor(
    private readonly dialog: MatDialog,
    private dialogRef: MatDialogRef<OptInModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly eventTrackingService: EventTrackingService
  ) {}

  ngOnInit(): void {
    this.eventTrackingService.trackEnterpriseEvent({
      eventRepo: 'customerPortal',
      eventName: 'optInDisplayed',
      optInDisplayType: 'modal',
      customerPortalDisclosureText: this.customerPortalDisclosureText,
      cid: this.data.cid,
    });
  }

  closeOptInModal(status: boolean) {
    this.dialogRef.close({ agreeToOptIn: status });
    let linkType = status ? 'creditProfileAuthorization' : 'exitOptIn';
    let linkText = status ? 'Agree' : 'Exit Modal';

    this.eventTrackingService.trackEnterpriseEvent({
      customerPortalClickLinkText: linkText,
      customerPortalClickLinkType: linkType,
      eventRepo: 'customerPortal',
      eventName: 'linkClick',
      cid: this.data.cid,
    });
  }

  disclosureClick() {
    this.dialog.open(OptInModalDisclosureComponent, {
      width: '529px',
      maxHeight: '90vh',
      data: { cid: this.data.cid },
    });
  }
}
